export default "__VITE_ASSET__RXFDEPJF__"